import { render } from "./Uptime.vue?vue&type=template&id=6c8e9766&scoped=true"
import script from "./Uptime.vue?vue&type=script&lang=js"
export * from "./Uptime.vue?vue&type=script&lang=js"

import "./Uptime.vue?vue&type=style&index=0&id=6c8e9766&scoped=true&lang=css"

import exportComponent from "D:\\EZENMS_VUE\\eze-nms-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8e9766"]])

export default __exports__